<template>
  <div class="col-12 mx-auto overflow-hidden">
    <h1 class="title">Kostenlose Maschinenbewertung</h1>
    <div class="col-12 mx-auto border-box">
      <div class="flex stage-container mb3 small-border-radius">
        <div class="formstage bgcolor1 pointer" @click="changeStep((step = 0))">
          <p class="formstage-text passed">
            <svg
              width="20"
              height="21"
              viewBox="0 0 20 21"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M10 0.5C4.5 0.5 0 5 0 10.5C0 16 4.5 20.5 10 20.5C15.5 20.5 20 16 20 10.5C20 5 15.5 0.5 10 0.5ZM8 15.5L3 10.5L4.41 9.09L8 12.67L15.59 5.08L17 6.5L8 15.5Z"
                fill="#0176CD"
              />
            </svg>
            <span>Ihre Branche</span>
          </p>
          <span class="gray formstage-info">{{
            onboardingMachineBrancheDefault
          }}</span>
        </div>
        <div
          class="formstage bgcolor1 pointer"
          @click="changeStep((step = 100))"
        >
          <p class="formstage-text passed">
            <svg
              width="20"
              height="21"
              viewBox="0 0 20 21"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M10 0.5C4.5 0.5 0 5 0 10.5C0 16 4.5 20.5 10 20.5C15.5 20.5 20 16 20 10.5C20 5 15.5 0.5 10 0.5ZM8 15.5L3 10.5L4.41 9.09L8 12.67L15.59 5.08L17 6.5L8 15.5Z"
                fill="#0176CD"
              />
            </svg>
            <span>Ihre Maschine</span>
          </p>
          <span class="gray formstage-info"
            >{{ onboardingMachineCategoryDefault }}<br />{{
              onboardingManufacturerDefault
            }}
            {{ onboardingMachineTypeDefault }}</span
          >
        </div>
        <div
          class="formstage bgcolor1 pointer"
          @click="changeStep((step = 200))"
        >
          <p class="formstage-text passed">
            <svg
              width="20"
              height="21"
              viewBox="0 0 20 21"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M10 0.5C4.5 0.5 0 5 0 10.5C0 16 4.5 20.5 10 20.5C15.5 20.5 20 16 20 10.5C20 5 15.5 0.5 10 0.5ZM8 15.5L3 10.5L4.41 9.09L8 12.67L15.59 5.08L17 6.5L8 15.5Z"
                fill="#0176CD"
              />
            </svg>
            <span>Anschaffung</span>
          </p>
          <span class="gray formstage-info"
            >Baujahr {{ onboardingMachineYearDefault }}<br />{{
              onboardingMachineNettoPrice
            }}</span
          >
        </div>
        <div class="formstage bgcolor1">
          <p class="formstage-text passed">4. <span>Ihre Kontaktdaten</span></p>
        </div>
        <div class="formstage step-background-color">
          <p class="formstage-text">5. <span>Echtzeitbewertung</span></p>
        </div>
      </div>
      <br />
      <div class="container">
        <div class="text-box">
          <p>
            Bitte nennen Sie uns Ihre E-Mailadresse oder melden Sie sich mit Ihrem
            NetBid Kundenkonto an.
          </p>
        </div>
        <div class="account-option-box">
                    <div class="signup-box">
            <h2 class="signup-title">Gastzugang</h2>
            <h1 class="signup-title-2">Ohne Anmeldung fortfahren</h1>
            <p class="signup-text">
              Um Ihre kostenlose Bewertung zu erstellen, benötigen wir Ihre
              E-Mailadresse. Sie haben außerdem die Möglichkeit ein NetBid
              Kundenkonto zu erstellen.
            </p>

            <div class="relative">
              <input
                class="forminput signup-input"
                v-model="customers_email"
                placeholder="E-Mailadresse"
              />
              <div
                class="crossout white absolute"
                v-on:click="resetInput()"
                v-if="mailValid"
              >
                <svg
                  width="28"
                  height="28"
                  viewBox="0 0 28 28"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M14.0001 0.666626C6.66675 0.666626 0.666748 6.66663 0.666748 14C0.666748 21.3333 6.66675 27.3333 14.0001 27.3333C21.3334 27.3333 27.3334 21.3333 27.3334 14C27.3334 6.66663 21.3334 0.666626 14.0001 0.666626ZM11.3334 20.6666L4.66675 14L6.54675 12.12L11.3334 16.8933L21.4534 6.77329L23.3334 8.66663L11.3334 20.6666Z"
                    fill="#0176CD"
                  />
                </svg>
              </div>
            </div>

            <label class="dsgvo-container">
              <input
                type="checkbox"
                v-model="customers_dsgvo"
                @click="customers_dsgvo = !customers_dsgvo"
                :class="[not_filled_customers_dsgvo ? 'error' : '']"
              />
              <span
                class="dsgvo-check"
                :class="[customers_dsgvo ? 'dsgvo-container-checked' : '']"
              >
                <span class="dsgvo-tick" v-if="customers_dsgvo">
                  <svg
                    width="14"
                    height="11"
                    viewBox="0 0 14 11"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M0 5.42L5 10.42L14 1.42L12.59 0L5 7.59L1.41 4.01L0 5.42Z"
                      fill="#0176CD"
                    />
                  </svg>
                </span>
              </span>
              Ich bin einverstanden, dass die NetBid Finance GmbH meine Angaben
              für Zwecke der Korrespondenz und Übersendung aktueller
              Informationen per E-Mail verwendet. Meine Einwilligung kann ich
              jederzeit widerrufen. Weitere Informationen entnehme ich der
              <a href="https://www.leaseback.de/datenschutz/" target="_blank"
                >Datenschutzerklärung</a
              >.
            </label>
          </div>
          <div class="login-box">
            <h2 class="login-title">NETBID FINANCE LOGIN</h2>
            <h1 class="login-title-2">Anmeldung mit Kundenkonto</h1>
            <p class="login-text">
              Sie haben bereits ein Kundenkonto? Dann können Sie sich hier
              anmelden.
            </p>
            <input
              class="forminput login-input"
              v-bind:class="{ error: not_filled_login_email }"
              placeholder="E-Mailadresse"
              v-model="login_email"
            />
            <input
              type="password"
              class="password-input forminput login-input"
              v-bind:class="{ error: not_filled_login_password }"
              placeholder="Passwort"
              v-model="login_password"
            />
            <p class="login_error_helper" v-bind:class="{ visible: show_login_error }">{{ errorMessage}}</p>
            <submit-button
              class="login-button"
              :name="LoginButtonName"
              :validInput="loginValid"
              event_name="pre_submit_step_300_login"
            />
          </div>
        </div>
        <div class="signup-form" v-if="showSignupForm">
          <h1 class="form-title-2">Weitere freiwillige Angaben</h1>
          <div class="form-flex">
            <!--div class="mr2 input-box">
              <h2
                class="h-label gray"
                v-bind:class="{ error: not_filled_customers_password }"
              >
                Passwort festlegen und Konto erstellen
              </h2>
              <div class="relative">
                <input
                  v-if="showPassword"
                  class="forminput"
                  type="text"
                  v-bind:class="{ error: not_filled_customers_password }"
                  v-model="customers_password"
                  placeholder="Passwort"
                />
                <input
                  v-else
                  class="forminput"
                  type="password"
                  v-bind:class="{ error: not_filled_customers_password }"
                  v-model="customers_password"
                  placeholder="Passwort"
                />
                <div
                  class="password-show white absolute"
                  v-on:click="toggleShow()"
                >
                  <svg
                    width="30"
                    height="20"
                    viewBox="0 0 30 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M15.0002 6C13.9393 6 12.9219 6.42143 12.1717 7.17157C11.4216 7.92172 11.0002 8.93913 11.0002 10C11.0002 11.0609 11.4216 12.0783 12.1717 12.8284C12.9219 13.5786 13.9393 14 15.0002 14C16.061 14 17.0784 13.5786 17.8286 12.8284C18.5787 12.0783 19.0002 11.0609 19.0002 10C19.0002 8.93913 18.5787 7.92172 17.8286 7.17157C17.0784 6.42143 16.061 6 15.0002 6ZM15.0002 16.6667C13.2321 16.6667 11.5364 15.9643 10.2861 14.714C9.03587 13.4638 8.3335 11.7681 8.3335 10C8.3335 8.23189 9.03587 6.5362 10.2861 5.28595C11.5364 4.03571 13.2321 3.33333 15.0002 3.33333C16.7683 3.33333 18.464 4.03571 19.7142 5.28595C20.9644 6.5362 21.6668 8.23189 21.6668 10C21.6668 11.7681 20.9644 13.4638 19.7142 14.714C18.464 15.9643 16.7683 16.6667 15.0002 16.6667ZM15.0002 0C8.3335 0 2.64016 4.14667 0.333496 10C2.64016 15.8533 8.3335 20 15.0002 20C21.6668 20 27.3602 15.8533 29.6668 10C27.3602 4.14667 21.6668 0 15.0002 0Z"
                      fill="#0176CD"
                    />
                  </svg>
                </div>
              </div>
            </div-->
            <br/>
            <div class="mr2 input-box">
              <h2
                class="h-label gray"
                v-bind:class="{ error: not_filled_customers_company }"
              >
                Unternehmen
              </h2>
              <input
                class="forminput"
                v-bind:class="{ error: not_filled_customers_company }"
                placeholder="Name Ihres Unternehmens"
                v-model="customers_company"
              />
            </div>
          </div>
          <br/>
          <div class="form-flex">
            <div class="input-box">
              <h2
                class="h-label gray"
                v-bind:class="{ error: not_filled_customers_name }"
              >
                Name
              </h2>
              <input
                class="forminput"
                v-bind:class="{ error: not_filled_customers_name }"
                placeholder="Nachname"
                v-model="customers_name"
              />
            </div>
          </div>
          <br/>
          <div class="form-flex">
            <div class="input-box">
              <h2
                class="h-label gray"
                v-bind:class="{
                  error: not_filled_customer_contact_phonenumber,
                }"
              >
                Telefonnummer
              </h2>
              <input
                class="forminput"
                type="number"
                v-bind:class="{
                  error: not_filled_customer_contact_phonenumber,
                }"
                placeholder="Telefonnummer"
                v-model="customer_contact_phonenumber"
              />
            </div>
          </div>
          <div class="button-flexbox align-center">
            <div>
              <a class="zueruck" @click="changeStep((step = 200))">Zurück</a>
            </div>
            <div>
              <submit-button
                :name="buttonName"
                :validInput="isValid"
                event_name="pre_submit_step_300"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="mb4" />
    </div>
    <cta-support-element />
  </div>
</template>

<script>
import { EventBus } from "@/event-bus.js";
import SubmitButton from "./SubmitButton.vue";
import CTASupportElement from "./CTASupportElement.vue";

export default {
  name: "OnboardingStep03",
  props: {
    name: String,
    event_name: String,
    button_style: String,
    onboardingMachineBrancheDefault: String,
    onboardingMachineCategoryDefault: String,
    onboardingManufacturerDefault: String,
    onboardingMachineTypeDefault: String,
    onboardingMachineYearDefault: String,
    onboardingMachineNettoPrice: String,
  },
  data() {
    return {
      debug: false,
      showSignupForm: false,
      login_email: "",
      login_password: "",
      errorMessage: "",
      customers_company: "",
      customers_email: "",
      customers_name: "",
      customer_contact_phonenumber: "",
      customers_dsgvo: "",
      not_filled_login_email: false,
      not_filled_login_password: false,
      show_login_error: false,
      not_filled_customers_company: false,
      not_filled_customers_email: false,
      not_filled_customers_name: false,
      not_filled_customer_contact_phonenumber: false,
      not_filled_customers_dsgvo: false,
      LoginButtonName: "Anmelden",
      buttonName: "Bestätigen und weiter",
      mailValid: false,
      loginValid: false,
      loginmailValid: false,
      isValid: false,
    };
  },
  created() {
    EventBus.$on("pre_submit_step_300", () => {
      // Kein payload!
      this.log("OnboardingStep03.vue: Event received: pre_submit_step_300");
      var allElementsReady = true;

      this.log("OnboardingStep03.vue: allElementsReady: " + allElementsReady);
      if (allElementsReady) {
        let this2 = this;
        setTimeout(function () {
          EventBus.$emit("submit_step_300", {
            customers_email: this2.customers_email,
            customers_company: this2.customers_company,
            customers_name: this2.customers_name,
            customer_contact_phonenumber: this2.customer_contact_phonenumber,
            customers_dsgvo: this2.customers_dsgvo,
            customers_password: this2.customers_password,
          });
        }, 500);
      }
    });
    EventBus.$on("pre_submit_step_300_login", () => {
      let this2 = this;
      setTimeout(function () {
        EventBus.$emit("submit_step_300_login", {
          login_email: this2.login_email,
          login_password: this2.login_password,
        });
      }, 500);
    });
    EventBus.$on("wrongCredentialsBackend", (payload) => {
      this.errorMessage = payload.message;
      this.show_login_error = true;

      if(this.errorMessage == "Das eingebene Passwort ist nicht korrekt."){
        this.not_filled_login_password = true;
        this.not_filled_login_email = false;
      }
      if(this.errorMessage == "E-Mail ist nicht verifiziert"){
        this.not_filled_login_email = true;
        this.not_filled_login_password = true;
      }
      if(this.errorMessage == "Die E-Mail Adresse wurde nicht gefunden"){
        this.not_filled_login_email = true;
        this.not_filled_login_password = false;
      }
    });

    EventBus.$on("evaluateNewMachine", () => {
        this.showSignupForm= false;
        this.login_email= "";
        this.login_password= "";
        this.errorMessage= "";
        this.customers_company= "";
        this.customers_email= "";
        this.customers_name= "";
        this.customer_contact_phonenumber= "";
        this.customers_dsgvo= "";
        this.not_filled_login_email= false;
        this.not_filled_login_password= false;
        this.show_login_error= false;
        this.not_filled_customers_company= false;
        this.not_filled_customers_email= false;
        this.not_filled_customers_name= false;
        this.not_filled_customer_contact_phonenumber= false;
        this.not_filled_customers_dsgvo= false;
        this.LoginButtonName= "Anmelden";
        this.buttonName= "Bestätigen und weiter";
        this.mailValid= false;
        this.loginValid= false;
        this.loginmailValid= false;
        this.isValid= false;
    });
  },
  watch: {
    customers_email: function () {
      console.log("customers_email");
      if (/(.+)@(.+){2,}\.(.+){2,}/.test(this.customers_email)) {
        this.mailValid = true;
        this.showSignupForm = true;
        this.isValid = true;
      } else {
        this.mailValid = false;
        this.showSignupForm = false;
      }
    },
    login_email: function () {
      if (/(.+)@(.+){2,}\.(.+){2,}/.test(this.login_email)) {
        this.loginmailValid = true;
        this.checkloginValidation();
      } else {
        this.loginmailValid = false;
        this.checkloginValidation();
      }
    },
    login_password: function (newValue, oldValue) {
      if (newValue != oldValue) {
        this.checkloginValidation();
      }
    },
  },
  components: {
    "submit-button": SubmitButton,
    "cta-support-element": CTASupportElement,
  },
  methods: {
    submit: function () {
      this.log(
        "OnboardingStep03.vue: Emitting Event using Submit: " + this.event_name
      );
      EventBus.$emit("" + this.event_name);
    },
    log: function (obj) {
      if (this.debug) {
        console.log(obj);
      }
    },
    checkloginValidation() {
      if (
        this.login_email != "" &&
        this.loginmailValid &&
        this.login_password != ""
      ) {
        this.loginValid = true;
      } else {
        this.loginValid = false;
      }
    },

    changeStep(step) {
      EventBus.$emit("changeStep", {
        step_number: step,
      });
    },
  },
};
</script>

<style scoped>
.h2_backwards {
  color: #9395a6;
  font-size: 20px;
}
.privacy_text {
  font-size: 13px;
  line-height: 17px;
}
.greenborder {
  outline: 2px solid #689b72;
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}

/* The container */
.checkbox-container {
  display: block;
  position: relative;
  padding-left: 45px;
  margin-bottom: 12px;
  cursor: pointer;
  font-size: 18px;
  font-weight: 300;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

/* Hide the browser's default checkbox */
.checkbox-container input[type="radio"] {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

/* Create a custom checkbox */
.checkmark {
  position: absolute;
  top: 2px;
  left: 0;
  height: 18px;
  width: 18px;
  background-color: #fff;
  border: 3px solid #0176CD;
  border-radius: 50%;
}
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the checkmark when checked */
.checkbox-container input[type="radio"]:checked ~ .checkmark:after {
  display: block;
}

/* Style the checkmark/indicator */
.checkbox-container .checkmark:after {
  left: 5px;
  top: 5px;
  width: 8px;
  height: 8px;
  background-color: #0176CD;
  border-radius: 50%;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}

.form-flex {
  display: flex;
}

.login-button{
  margin-top: 24px;
}

/* The container */
.dsgvo-container {
  display: block;
  position: relative;
  padding-left: 48px;
  margin-top: 12px;
  margin-bottom: 12px;
  cursor: pointer;
  font-size:14px;
  line-height: 150%;
  font-weight: 300;
  color: #fff;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.dsgvo-container-checked {
  background-color: #fff;
}

.dsgvo-container a {
  color: #fff;
  text-decoration: underline;
}

.dsgvo-container input[type="checkbox"] {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 20px;
  width: 20px;
}

.login_error_helper{
  color: #ff0000;
  text-align: center;
  display: none;
  margin-top: 10px;
  margin-bottom: 4px;
}

.visible{
  display: block;
}

.dsgvo-check {
  position: absolute;
  top: 3px;
  left: 13px;
  height: 24px;
  width: 24px;
  border: 2px solid #fff;
  box-sizing: border-box;
  border-radius: 5px;
}

.dsgvo-check::before {
  content: "";
  position: absolute;
  display: none;
}

.dsgvo-check::before .dsgvo-container {
  background-clip: #fff;
}

.dsgvo-container input[type="checkbox"]:checked ~ .dsgvo-check::before {
  display: block;
}

.dsgvo-tick {
  position: absolute;
  top: 3px;
  left: 3px;
}
.dsgvo-tick svg {
  width: 14px;
  vertical-align: text-top;
}

.input-box {
  width: 50%;
}

svg {
  vertical-align: sub;
  margin-right: 10px;
}

.account-option-box {
  display: flex;
  margin-bottom: 24px;
}

.login-box {
  width: 50%;
  margin-left: 24px;
  background-color: #f3f3f3;
  border-radius: 10px;
  padding: 2rem;
}

.password-input{
  margin-bottom: 0 !important;
}

.login-title {
  color: #0176CD;
  font-size: 1em;
  margin-bottom: 1rem;
  text-transform: uppercase;
}

.login-title-2 {
  color: #0176CD;
  font-size: 1.8em;
  margin-bottom: 1rem;
}

.form-title-2 {
  color: #0176CD;
  font-size: 1.8em;
  font-weight: 600;
  margin-bottom: 24px;
}

.login-text {
  color: #76798c;
  font-size: 1.1em;
  margin-bottom: 1.2rem;
}

.login-input {
  border: none;
  margin-bottom: 1rem;
}

.login-input:focus-visible {
  border: none !important;
}

.signup-box {
  width: 50%;
  background-color: #0176CD;
  border-radius: 10px;
  padding: 2rem;
}

.signup-title {
  color: #fff;
  font-size: 1em;
  margin-bottom: 1rem;
  text-transform: uppercase;
}

.signup-title-2 {
  color: #fff;
  font-size: 1.8em;
  margin-bottom: 1rem;
}

.signup-text {
  color: #fff;
  font-size: 1.1em;
  margin-bottom: 1.2rem;
}

.signup-input {
  border: none;
}

.signup-input:focus-visible {
  border: none !important;
}

.password-show {
  top: 17px;
  right: 5px;
  cursor: pointer;
}

@media (max-width: 1060px) {
  .account-option-box,
  .form-flex {
    flex-direction: column;
  }

  .input-box {
    width: 100%;
  }

  .login-box,
  .signup-box {
    width: 92%;
    margin: auto;
  }

  .login-box {
    margin-top: 24px;
  }
}

@media (max-width: 880px) {
  .login-box,
  .signup-box {
    width: 90%;
  }
}

@media (max-width: 700px) {
  .login-box,
  .signup-box {
    padding: 2rem 1rem;
  }
}

@media (max-width: 320px) {
  .login-box,
  .signup-box {
    width: 83%;
  }
}
</style>
